import RouteTemplate from "ember-route-template";
import eq from "truth-helpers/helpers/eq";

export default RouteTemplate(
  <template>
    <div class="pd-breadcrumbs">
      <a href="/">HOME</a>
      <span class="pd-breadcrumbs__sep">/</span>
      <a href="/providers/compare">COMPARISONS</a>
      <span class="pd-breadcrumbs__sep">/</span>
      <span>{{@controller.model.comparison.title}}</span>
    </div>

    <article class="pd-comparison">
      <header class="pd-comparison__hero">
        <h1 class="pd-comparison__title">{{@controller.model.comparison.title}}</h1>

        {{#if @controller.model.comparison.summary}}
          <p class="pd-comparison__summary">{{@controller.model.comparison.summary}}</p>
        {{/if}}

        {{#if @controller.model.winnerName}}
          <div class="pd-comparison__winner-badge">
            Recommended: <strong>{{@controller.model.winnerName}}</strong>
          </div>
        {{/if}}
      </header>

      {{#if @controller.model.rows.length}}
        <div class="pd-comparison__matrix-wrapper">
          <h2 class="pd-comparison__section-title">Feature Comparison</h2>
          <div class="pd-comparison__table-scroll">
            <table class="pd-comparison-matrix">
              <thead>
                <tr>
                  <th class="pd-comparison-matrix__feature-col">Feature</th>
                  <th>{{@controller.model.providerAName}}</th>
                  <th>{{@controller.model.providerBName}}</th>
                </tr>
              </thead>
              <tbody>
                {{#each @controller.model.rows as |row|}}
                  <tr>
                    <td class="pd-comparison-matrix__feature">{{row.label}}</td>
                    <td class="{{if (eq row.winnerSide 'a') 'pd-comparison-matrix__cell--winner'}}">{{row.a}}</td>
                    <td class="{{if (eq row.winnerSide 'b') 'pd-comparison-matrix__cell--winner'}}">{{row.b}}</td>
                  </tr>
                {{/each}}
              </tbody>
            </table>
          </div>
        </div>
      {{/if}}

      {{#if @controller.model.comparison.verdict}}
        <section class="pd-comparison__verdict">
          <h2 class="pd-comparison__section-title">Our Verdict</h2>
          <p class="pd-comparison__verdict-body">{{@controller.model.comparison.verdict}}</p>
        </section>
      {{/if}}

      {{#if @controller.model.faq.length}}
        <section class="pd-comparison__faq">
          <h2 class="pd-comparison__section-title">Frequently Asked Questions</h2>
          <div class="pd-comparison__faq-list">
            {{#each @controller.model.faq as |item idx|}}
              <details class="pd-comparison__faq-item" id="faq-{{idx}}">
                <summary class="pd-comparison__faq-question">
                  <span>{{item.q}}</span>
                  <span class="pd-comparison__faq-toggle">&#9660;</span>
                </summary>
                <div class="pd-comparison__faq-answer">
                  <p>{{item.a}}</p>
                </div>
              </details>
            {{/each}}
          </div>
        </section>
      {{/if}}

      <div class="pd-comparison__cta-row">
        <a class="pd-comparison__cta" href="/providers/{{@controller.model.comparison.provider_a_slug}}">
          View {{@controller.model.providerAName}} &rarr;
        </a>
        <a class="pd-comparison__cta pd-comparison__cta--alt" href="/providers/{{@controller.model.comparison.provider_b_slug}}">
          View {{@controller.model.providerBName}} &rarr;
        </a>
      </div>

      {{#if @controller.model.relatedGuides.length}}
        <section class="pd-comparison__related">
          <h2 class="pd-comparison__section-title">Related Guides</h2>
          <div class="pd-comparison__related-grid">
            {{#each @controller.model.relatedGuides as |g|}}
              <a class="pd-comparison__related-card" href="/guides/{{g.slug}}">
                <h4>{{g.title}}</h4>
                <p>{{g.excerpt}}</p>
              </a>
            {{/each}}
          </div>
        </section>
      {{/if}}
    </article>
  </template>
);
